import React from "react";
import Card from "react-bootstrap/Card";

function SalesCards(props) {
  const { imgPath, title, description} = props;
  return (
    <Card className="sales-card-view">
      <Card.Img style={{backgroundColor:"white"}} variant="top" src={imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title className="purple">{title}</Card.Title>
        <Card.Text style={{ textAlign: "center" }}>
          {description}
        </Card.Text>
        {"\n"}
        {"\n"}
      </Card.Body>
    </Card>
  );
}
export default SalesCards;
